<style scoped>
.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 20px auto;
  width: 70%;
  padding: 20px 60px;
}
.cost-title {
  /* height: 72px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 14px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  align-items: center;
}
.cost-approve-list-title {
  width: 180px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  flex-direction: row-reverse;
  padding-bottom: 30px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
/* 表头设置 */
.setHeadClass .setHead {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.setHeadClass .setHead p {
  margin: 0;
}

.setHeadClass .setHead .left {
  width: 300px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  margin-right: 10px;
  height: 556px;
  overflow-y: scroll;
}

.setHeadClass .setHead .right {
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
}

.setHeadClass .setHead .right .top {
  text-align: right;
  margin-bottom: 12px;
}
.btnArea span {
  text-decoration: underline;
  color: #4fa1a4;
  margin-left: 12px;
  cursor: pointer;
}
.product {
  display: flex;
  align-items: center;
}
.product-img {
  width: 60px;
  height: 40px;
  margin-right: 15px;
}
.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cost-input {
  width: 300px;
}
.add-label-btn {
  width: 80px;
  height: 40px;
  line-height: 36px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  background: #4fa1a4;
}
.label-box {
  display: flex;
}
.upload-list{
  width: 500px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 24px;
}
.upload-list-del{
  margin-right: 10px;
  cursor: pointer;
}
 /*被拖拽对象的样式*/
.dragg-item {
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  /* cursor: move; */
} 
.chosen{
  color: #4fa1a4;
  cursor: move;
  border: solid 2px #adaeaf !important;
}
</style>
<template>
  <div class="cost-content">
    <div class="costApprove" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="cost-title">
        <div class="flow-name">居间人资料</div>
        <div class="flow-back" @click="goBack()">返回</div>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">基本信息</span>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>所属企业：</div>
         <el-select :disabled ="disabled||$route.query.guid" v-model="form.tenantGuid" filterable placeholder="请选择" class="cost-input" @change="changeCompany" >
          <el-option
            v-for="item in companyList"
            :key="item.sendTenantGuid"
            :label="item.sendTenantName"
            :value="item.sendTenantGuid"
          >
          </el-option>
        </el-select>
      </div>
      
      <!-- 姓名： -->
      <div class="cost-approve-list" v-show="getFieldConfig('clientName', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('clientName', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("clientName", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled"
            ref="clientNameRef"
            @input="form.clientName=form.clientName.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')"  
            @blur="nameBlur(form.clientName,form,'clientName')"
            type="text"
            v-model.trim="form.clientName"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('clientName', 'tipText')"
            :maxlength="50"
          ></el-input>
        </div>
      </div>
      <!-- 联系方式： -->
      <div class="cost-approve-list" v-show="getFieldConfig('mobileNo', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('mobileNo', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("mobileNo", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled"
            @input="form.mobileNo=form.mobileNo.replace(/[^\d\-\d]/g,'')"
            type="text"
            v-model.trim="form.mobileNo"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('mobileNo', 'tipText')"
          ></el-input>
        </div>
      </div>
      <!-- 性别： -->
      <div class="cost-approve-list" v-show="getFieldConfig('sex', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('sex', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("sex", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
           <el-select :disabled ="disabled" v-model="form.sex" class="cost-input" :placeholder="getFieldConfig('sex', 'tipText')" filterable>
            <el-option v-for="item in transform(getFieldConfig('sex', 'selectItemList'))" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 岗位： -->
      <div class="cost-approve-list" v-show="getFieldConfig('position', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('position', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("position", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-cascader :disabled ="disabled" :placeholder="getFieldConfig('position', 'tipText')" class="w300" ref="cascaderAddr" v-model="form.positionGuid" @change="handlePosition"
              :options="positionList" clearable :props="cascaderProps" filterable></el-cascader>
        </div>
      </div>
      <!-- 客户类型： -->
      <div class="cost-approve-list" v-show="getFieldConfig('terminalType', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('terminalType', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("terminalType", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
           <el-select :disabled ="disabled" v-model="terminalType" class="cost-input" :placeholder="getFieldConfig('terminalType', 'tipText')" filterable @change="terminalChange">
            <el-option v-for="item in transform(getFieldConfig('terminalType', 'selectItemList'))" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 负责客户： -->
      <div class="cost-approve-list" v-show="getFieldConfig('chargeCustomerList', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('chargeCustomerList', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("chargeCustomerList", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled"
            type="text"
            v-model="customerListName"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('chargeCustomerList', 'tipText')"
            @focus="customerChange"
          ></el-input>
        </div>
      </div>
      <!-- 代理产品： -->
      <div class="cost-approve-list" v-show="getFieldConfig('agentProductList', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('agentProductList', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("agentProductList", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled"
            type="text"
            v-model="productName"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('agentProductList', 'tipText')"
            @focus="chooseProduct"
          ></el-input>
        </div>
      </div>
      <!-- 业务员能力： -->
      <div class="cost-approve-list" v-show="getFieldConfig('businessAbility', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('businessAbility', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("businessAbility", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
           <el-select :disabled ="disabled" v-model="form.businessAbility" class="cost-input" :placeholder="getFieldConfig('businessAbility', 'tipText')" filterable>
            <el-option v-for="item in transform(getFieldConfig('businessAbility', 'selectItemList'))" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 业绩指标： -->
      <div class="cost-approve-list" v-show="getFieldConfig('performanceIndicator', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('performanceIndicator', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("performanceIndicator", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-input :disabled ="disabled"
            type="text"
            v-model.trim="form.performanceIndicator"
            autocomplete="off"
            class="cost-input"
            :placeholder="getFieldConfig('performanceIndicator', 'tipText')"
            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
            :maxlength="50"
          ></el-input>
        </div>
      </div>
      <!-- 擅长品类： -->
      <div class="cost-approve-list" v-show="getFieldConfig('adeptType', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('adeptType', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("adeptType", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
           <el-select :disabled ="disabled" v-model="form.adeptType" class="cost-input" multiple :placeholder="getFieldConfig('adeptType', 'tipText')" filterable>
            <el-option v-for="item in transform(getFieldConfig('adeptType', 'selectItemList'))" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 专长领域： -->
      <div class="cost-approve-list" v-show="getFieldConfig('expertDomainList', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('expertDomainList', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("expertDomainList", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-cascader  class="cost-input" :options="concactTypeOption"  clearable size="small" v-model="form.expertDomainList" :props="{checkStrictly: false,}"  :placeholder="getFieldConfig('expertDomainList', 'tipText')">
          </el-cascader>
        </div>
      </div>
      <!-- 覆盖区域： -->
      <div class="cost-approve-list" v-show="getFieldConfig('coverageAreaList', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('coverageAreaList', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("coverageAreaList", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-cascader ref="cascaderFirst" class="cost-input" :options="options" collapse-tags  clearable size="small" v-model="cityList" :props="{checkStrictly: false,value:'code',multiple: true}" @change="incres" >
          </el-cascader>
        </div>
      </div>
      <!-- 建档时间： -->
      <div class="cost-approve-list" v-show="getFieldConfig('inputDate', 'formVisible') == 'Y'">
        <div class="cost-approve-list-title"><span class="fontC-red" v-show="getFieldConfig('inputDate', 'isRequired') == 'Y'">*</span>{{ getFieldConfig("inputDate", "fieldAlias") }}：</div>
        <div class="cost-approve-list-content">
          <el-date-picker :disabled ="disabled"
            class="cost-input"
            v-model="form.inputDate"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="getFieldConfig('inputDate', 'tipText')">
          </el-date-picker>
        </div>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>指派公司：</div>
         <el-select :disabled ="disabled" v-model="form.createUserTenantGuid" filterable placeholder="请选择" class="cost-input" @change="onChanCreateUserTenant">
          <el-option
            v-for="item in serviceTenants"
            :key="item.guid" 
            :label="item.tenantName" 
            :value="item.guid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>业务指派人员：</div>
         <el-select :disabled ="disabled" v-model="form.createUserId" filterable placeholder="请选择" class="cost-input" @change="changeStaff">
          <el-option
            v-for="item in staffList"
            :key="item.userGuid"
            :label="item.staffName + ' - ' + item.mobileNo"
            :value="item.userGuid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="cost-approve-list">
        <div class="cost-approve-list-title"><span class="fontC-red">*</span>启用状态：</div>
        
        <el-radio-group class="cost-input" :disabled="disabled" v-model="form.bizState">
          <el-radio label="Y">启用</el-radio>
          <el-radio label="S">停用</el-radio>
        </el-radio-group>
      </div>
      <div class="cost-submit-btn mt15">
        <div class="cost-submit-btn-sure" @click="submit(1)">添加下一个</div>
        <div class="cost-submit-btn-sure" @click="submit()">提 交</div>
        <div class="cost-submit-btn-cancel" @click="$router.go(-1)">取 消</div>
      </div>
    </div>
    <div class="h20"></div>
    <el-dialog :title="'请选择'+getFieldConfig('chargeCustomerList', 'fieldAlias')" :visible.sync="dialogMed" :modal-append-to-body="false" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">关键字：</div>
          <el-input :disabled ="disabled" v-model="joinKeyWords" class="ipt-sty" placeholder="请输入名称"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="getAssociated(true)">搜索</el-button>
        </el-col>
      </el-row>
      <!-- 医院 -->
      <el-table :data="medList" style="width: 100%" height="50vh" row-key="guid" border ref="dataTableMed" @row-click="rowClickMed" @selection-change="handleSelectionChangeMed" v-loading="medLoading">
        <el-table-column width="60" label="选择" header-align="center" align="center" type="selection" :reserve-selection="true" >
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (medPage.pageIndex - 1) * medPage.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="medName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="所在区域" header-align="center" align="center" width="300">
          <template slot-scope="scope">{{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district}}</template>
        </el-table-column>
        <el-table-column prop="price" label="详细地址" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            {{ scope.row.address||'-' }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 医院分页 -->
      <el-pagination  class="pt pb back-color-fff" background @size-change="handleMedSizeChange" @current-change="handleMedCurrentChange" :page-sizes="[10, 30, 50]" :current-page="medPage.pageIndex" :page-size="medPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="medPage.totalRows">
      </el-pagination> 
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="cancelChoose">取消</el-button>
        <el-button size="medium" type="info" @click="sureChoose">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'请选择'+getFieldConfig('chargeCustomerList', 'fieldAlias')" :visible.sync="dialogFran" :modal-append-to-body="false" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">关键字：</div>
          <el-input :disabled ="disabled" v-model="joinKeyWords" class="ipt-sty" placeholder="请输入名称"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="getAssociated(true)">搜索</el-button>
        </el-col>
      </el-row>
      <!-- 商业公司 -->
      <el-table :data="franchiseeList" style="width: 100%" height="50vh" row-key="guid" border ref="dataTableFran" @row-click="rowClickFran"  @selection-change="handleSelectionChangeFran" v-loading="franLoading">
        <el-table-column width="60" label="选择" header-align="center" align="center" :reserve-selection="true" type="selection" >
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (franPage.pageIndex - 1) * franPage.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="franchiseeName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="所在区域" header-align="center" align="center" width="300">
          <template slot-scope="scope">{{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district}}</template>
        </el-table-column>
        <el-table-column prop="price" label="详细地址" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            {{ scope.row.address||'-' }}
          </template>
        </el-table-column>
      </el-table>
      <!--商业公司分页 -->
      <el-pagination  class="pt pb back-color-fff" background @size-change="handleFranSizeChange" @current-change="handleFranCurrentChange" :page-sizes="[10, 30, 50]" :current-page="franPage.pageIndex" :page-size="franPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="franPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="cancelChoose">取消</el-button>
        <el-button size="medium" type="info" @click="sureChoose">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择产品 -->
      <el-dialog title="选择产品" :visible.sync="dialogProduct" width="900px">
        <el-row :gutter="24" class="mb30">
          <el-col :span="13">
            <div class="search-area-div w80">产品名称：</div>
            <el-input :disabled ="disabled" v-model="pages.goodsName" class="ipt-sty" placeholder="请输入" clearable></el-input>
          </el-col>
          <el-col :span="3">
            <el-button size="medium" type="info" @click="getProduct(1)">搜索</el-button>
          </el-col>
        </el-row>
        <!-- <div class="product-select-all"><el-checkbox style="display:flex;align-items: center;" v-model="checkedAllProduct" @change="checkedAllProductChange">全选</el-checkbox></div> -->
        <el-table
          :data="productInformationList"
          style="width: 100%"
          :row-key="getRowKeys"
          border
          v-loading="loading"
          ref="dataTableProduct"
          @row-click="rowClickProduct"
          height="60vh"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (pages.pageIndex - 1) * pages.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="product">
                <img class="product-img" :src="scope.row.pictContent | filterImgUrl" alt="" />
                <p class="product-text w247">{{ scope.row.goodsName }}</p>
              </div>
              <!-- <p class="select-tip" v-show="(isChangePrice == 0&&scope.row.priceType ==2)||(isChangePrice == 0&&scope.row.priceType ==1&&scope.row.price ==0)||(isChangePrice == 0&&scope.row.priceType ==1&&!scope.row.price)">无法加购，请联系运营是否需要支持自行填价</p> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsSpec"
            label="规格"
            header-align="center"
            align="left"
            width="170"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="producer"
            label="生产企业"
            header-align="center"
            align="center"
            width="170"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="price" label="单价" header-align="center" align="right" width="120">
            <template slot-scope="scope">
              <!-- 固定价 -->
              <span v-if="scope.row.priceType == '1' && scope.row.price !== 0 && scope.row.price">{{
                scope.row.price | numDigit | numFmt
              }}</span>
              <!-- 区间价 -->
              <span v-if="scope.row.priceType == '2'">
                {{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt }}
              </span>
              <span v-if="scope.row.priceType == '1' && (scope.row.price == 0 || !scope.row.price)">未定价</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pages.pageIndex"
          :page-size="pages.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="pages.totalRows"
        >
        </el-pagination>
        <div slot="footer" class="dialog-footer">
          <p class="t-left fl">本次已选择{{ multipleSelectionGoodsList.length }}个产品</p>
          <el-button plain size="medium" @click="dialogProduct = false">取消</el-button>
          <el-button size="medium" type="info" @click="submitFormProduct()">确定</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import provinceData from '../../assets/js/cityList';
import { Alert } from 'element-ui';
import recentDate from "@/uilt/recentDate";
export default {
  data() {
    return {
          disabled:(this.$route.query.disabled == 'false'||!this.$route.query.disabled) ? false : true,
      fullscreenLoading:false,
      loading:false,
      currentCompany:'',
      form: {
        guid: '',
        tenantGuid: '',
        clientName: '',//姓名
        tenantGuid: "",
        mobileNo: "",
        sex: "",
        position: '',//岗位
        positionGuid:'',
        department:'',//部门
        departmentGuid:'',
        clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        chargeCustomerList:[],
        agentProductList:[],//产品
        businessAbility:[],//业务员能力
        performanceIndicator:'',//业绩指标
        adeptType:[],//擅长品类
        expertDomainList:[],//专长领域
        coverageAreaList:[],//覆盖城市
        inputDate: recentDate.getNowDay(),
        accountMonth: null,
        createUserTenantGuid: '',
        createUserId:'',
        createUserMobile:'',
        createUserName:'',
        bizState:'Y',//启用状态
      },
      terminalType:'',//选择类型 2商业公司 1医院
      //专长领域
      concactTypeOption: [
        {
          label: '第一终端',
          value: '第一终端',
          children:[
            {
              label: '等级医院',
              value: '等级医院',
            },
          ]
        },{
          label: '第二终端',
          value: '第二终端',
          children:[
            {
              label: '药店',
              value: '药店',
            },
            {
              label: '连锁药店',
              value: '连锁药店',
            },
            {
              label: '单体药店',
              value: '单体药店',
            },
            {
              label: '网上药店',
              value: '网上药店',
            },
          ]
        },
        {
          label: '第三终端',
          value: '第三终端',
          children:[
            {
              label: '民营医院',
              value: '民营医院',
            },
            {
              label: '诊所',
              value: '诊所',
            },
            {
              label: '社区卫生中心',
              value: '社区卫生中心',
            },
            {
              label: '乡镇卫生院',
              value: '乡镇卫生院',
            },
          ]
        }
      ],
      cityList:[],
      options: provinceData, //调用外部js文件的json数据
      // 商业公司
      customerListName:'',
      dialogFran:false,
      dialogMed:false,
      franchiseeList:[],
      medList:[],
      currentMedSelect: [],
      currentFranSelect:[],
      medLoading:false,
      franLoading:false,
      franPage: {
        pageIndex: 1,
        tenantGuid: localStorage.guid,
        pageSize: 10,
        franchiseeName: '',
        totalPage: 0,
        totalRows: 0,
      },
      joinKeyWords:'',
      medPage: {
        pageIndex: 1,
        tenantGuid: localStorage.guid,
        pageSize: 10,
        medNameKeyword: '',
        approvalStates: ["Y", "U"],
        totalPage: 0,
        totalRows: 0,
      },
      //产品
      dialogProduct:false,
      productInformationList: [],
      productName: '',
      productSelectList: [],
      pages: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        goodsName: '',
        isPrescription: '',
        staffGuid: '',
        totalPage: 0,
        totalRows: 0,
      },
      multipleSelectionGoodsList: [],
      companyList:[],
      serviceTenants: [],
      staffList:[],
      staffData:'',
      currentStaffGuid:'',
      positionList:[],
      cascaderProps: { //角色级联
          value: 'guid',
          label: 'text',
          children: 'childDictList',
          multiple: false,
          emitPath:false
      },
    };
  },
  watch: {
    'form.inputDate'(v) {
      if (v) {
        this.getAccountMonth();
      }
    },
  },
  async created() {
    console.log('first3333',this.options)
    let userInfo = JSON.parse(localStorage.userInfo);
    this.currentCompany = userInfo.tenantName;
    if(!this.$route.query.guid){
      sessionStorage.removeItem('businessPageIndex')
    }
    if (this.$route.query.guid) {
      this.form.guid = this.$route.query.guid;
      await this.getCompany();
      await this.getData();
      this.getServiceTenants(this.form.tenantGuid);
    }else{
      this.getMedList(true);
      this.getFranchiseeList(true);
      this.getProduct(1)
      if (this.$route.query.tenantGuid) {
        this.form.tenantGuid=this.$route.query.tenantGuid
        this.form.createUserTenantGuid = this.form.tenantGuid;
        this.getServiceTenants(this.form.createUserTenantGuid);
      }
      
    }
    this.getAccountMonth();
    if(!this.$route.query.guid){
      this.getCompany()
    }
    this.getPositionList();
  },
  methods: {
    goBack(){
      sessionStorage.setItem('businessBack',1) 
      this.$router.go(-1)
    },
    getPositionList() {
      this.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=部门名称字典`
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let positionList =  res.data.data;
            positionList.forEach(item=>{
              item.childDictList.forEach(el=>{
                delete el.childDictList
              })
            })
            this.positionList = positionList;
       
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    handlePosition(){
      let obj = this.$refs['cascaderAddr'].getCheckedNodes()[0];
      this.form.positionGuid = obj.path[1];
      this.form.departmentGuid = obj.path[0];
      this.form.position = obj.pathLabels[1];
      this.form.department = obj.pathLabels[0];
    },
    transform(list,type) {
      var newList = [];
      if(type ==1){
        list.forEach((item) => {
          newList.push({
            key: item.text,
            value: item.text,
          });
        });
      }else{
        if(list){
          list.forEach((item) => {
            newList.push({
              name: item.text,
              value: item.value,
            });
          });
        }
      }
      return newList;
    },
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem("TXL_CONFIG")).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    rowClickMed(row,event,column){
      row.flag = !row.flag;
      this.$refs.dataTableMed.toggleRowSelection(row, row.flag);
    },
    rowClickFran(row,event,column){
      row.flag = !row.flag;
      this.$refs.dataTableFran.toggleRowSelection(row, row.flag);
    },
    terminalChange(){
      this.currentMedSelect = [];
      this.currentFranSelect = [];
      this.customerListName = ''
      this.getMedList(1);
      this.getFranchiseeList(1);
    },
    getAssociated() {
      if (this.terminalType == 2) {
        this.getFranchiseeList(true);
      }
      if (this.terminalType == 1) {
        this.getMedList(true)
      }
    },
    changeCompany(val){
      this.form.tenantGuid = val;
      this.form.createUserTenantGuid = '';
      this.form.createUserId = '';
      this.getMedList(1);
      this.getFranchiseeList(1);
      this.getProduct(1)
      this.getServiceTenants(val);
    },
    onChanCreateUserTenant(val) {
      this.form.createUserTenantGuid = val;
      this.form.createUserId = '';
      this.getStaff(val);
    },
    getServiceTenants(tenantGuid) {
      if (!tenantGuid) {
        tenantGuid = this.form.createUserTenantGuid;
      }
      const params = {
        tenantGuid: tenantGuid,
        isService: false,
      }
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-service-tenants`,
          params,
        )
        .then((res) => {
          if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.error(res.data.msg);
            return;
          }
          this.serviceTenants = res.data.data;
          this.getStaff(this.form.createUserTenantGuid);
        });
    },
    changeStaff(val){
      if(this.staffList&&this.staffList.length>0){
        this.staffList.forEach(i=>{
          if(val == i.userGuid){
            this.currentStaffGuid = i.guid;
            this.form.createUserMobile = i.mobileNo;
            this.form.createUserName = i.staffName;
          }
        })
      }
    },
     //获取人员下拉
    getStaff(val){
      if(!this.form.tenantGuid){
        return 
      }
      let tenantGuid = this.form.tenantGuid;
      if (val) {
        tenantGuid = val;
      }
      this.api.get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` +  tenantGuid 
      ).then( (res)=> {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
          
        }
      });
    },
    //获取公司
    getCompany() {
      return new Promise ((resolve,reject)=>{
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.companyList = res.data.data || [];
              // if(self.companyList&&self.companyList.length>0 &&!this.$route.query.guid){
              //   this.form.tenantGuid = self.companyList[0].sendTenantGuid;
              // }
              this.getMedList(1);
              this.getFranchiseeList(1);
              this.getProduct(1)
              resolve()
            } else {
              self.$message.error(res.data.msg);
            }
          });
      })
    },
    customerChange(){
      if(!this.form.tenantGuid){
        this.$message.error('请先选择所属企业！')
        return
      }
      if(!this.terminalType){
        this.$message.error('请先选择客户类型！')
        return
      }
      if(this.terminalType == 1){
        this.dialogMed = true;
      }else if(this.terminalType == 2){
        this.dialogFran = true;
      }
      this.getAssociated()
    },
    //产品点击
    rowClickProduct(row,event,column){
      row.flag = !row.flag;
      this.$refs.dataTableProduct.toggleRowSelection(row, row.flag);
    },
    //获取核算月
    getAccountMonth() {
      if (!this.form.inputDate) return;
      let self = this;
      let tenantGuid = localStorage.guid;
      this.api.get(`/${serverConfig.msConfigureService}/sysparameter/data/get-account-month?date=` +
        this.form.inputDate +
        "&tenantGuid=" +
        tenantGuid
      ).then(function (resp) {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.form.accountMonth = resp.data.data.substr(0, 4) + "-" + resp.data.data.substr(4, 2);
        }
      });
    },
    async getData() {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      await self.api
        .postJson(`/${serverConfig.msPersonnelService}/address-list/data/queryDetail`,{guid:this.$route.query.guid})
        .then((res) => {
          if (res.data.msg == 'success') {
            let data = res.data.data;
            this.form = {
              guid: data.guid,
              tenantGuid: data.tenantGuid,
              clientName: data.clientName,//姓名
              tenantGuid: data.tenantGuid,
              mobileNo: data.mobileNo,
              sex: data.sex,
              position: data.position,//岗位
              positionGuid: data.positionGuid,
              department: data.department,//部门
              departmentGuid: data.departmentGuid,
              clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
              agentProductList:[],//产品
              businessAbility:data.businessAbility,//业务员能力
              performanceIndicator:data.performanceIndicator,//业绩指标
              adeptType:data.adeptType?data.adeptType.split('、'):[],//擅长品类
              expertDomainList:[],//专长领域
              coverageAreaList:[],//覆盖城市
              inputDate: this.$moment(data.inputDate).format('YYYY-MM-DD'),
              accountMonth: data.accountMonth,
              createUserId:data.createUserId,
              createUserMobile:data.createUserMobile,
              createUserName:data.createUserName,
              bizState:data.bizState,
              createUserTenantGuid: data.createUserTenantGuid || data.tenantGuid,
            }
            //客户
            if(data.chargeCustomerList){
              this.terminalType = data.chargeCustomerList[0].customerType;
              if(this.terminalType == 1){
                this.currentMedSelect = data.chargeCustomerList;
                let medNameList = [];
                this.currentMedSelect.forEach((i,index)=>{
                  if(index<2){
                    medNameList.push(i.customerName);
                  }
                })
                console.log(medNameList)
              this.customerListName =  this.currentMedSelect.length>2?(medNameList.join('、')+'等'+this.currentMedSelect.length+'个'):(medNameList.join('、'))
              }else{
                this.currentFranSelect = data.chargeCustomerList;
                let franNameList = [];
                console.log(this.currentFranSelect)
                this.currentFranSelect.forEach((i,index)=>{
                  if(index<2){
                    franNameList.push(i.customerName);
                  }
                })
                this.customerListName =  this.currentFranSelect.length>2?(franNameList.join('、')+'等'+this.currentFranSelect.length+'个'):(franNameList.join('、'))
                
              }
            }
            //产品
            if(data.agentProductList&&data.agentProductList.length>0){
              this.multipleSelectionGoodsList = data.agentProductList;
              let goodsList = []
              this.multipleSelectionGoodsList.forEach((i,index) => {
                if(index<2){
                  goodsList.push(i.productName);
                }
              });
              this.productName = this.multipleSelectionGoodsList.length>2?(goodsList.join('、')+'等'+this.multipleSelectionGoodsList.length+'个'):(goodsList.join('、'));
            }
            //专长领域
            if(data.expertDomainList&&data.expertDomainList.length>0){
              this.form.expertDomainList = [data.expertDomainList[0].expertCustomerType,data.expertDomainList[0].expertCustomerName]
              console.log(this.form.expertDomainList)
            }
            // 覆盖城市
            if(data.coverageAreaList&&data.coverageAreaList.length>0){
              this.cityList = [];
              provinceData.forEach(m=>{
                m.children.forEach(n=>{
                  data.coverageAreaList.forEach(p=>{
                    if(n.code == p.city){
                      let obj = [m.code,p.city]
                      this.cityList.push(obj)
                    }
                  })
                })
              })
              console.log(this.cityList)

            }
          } else {
            self.$message.error(res.data.data.msg);
          }
        });
    },
    mobileNoChange(val){
      let reg01 =/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
      if(!reg01.test(val)){
        this.form.mobileNo = '';
        this.$message.error('请填写正确联系方式');
      }
    },
    incres(area) {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes()
      let arr = checkedNodes[0].pathNodes
      let codeArr = []
      arr.forEach(item => {
        codeArr.push(item.data.value)
      })
      console.log(this.cityList)
      // this.ruleForm.province = codeArr[0];
      // this.ruleForm.city = codeArr[1];
      // this.ruleForm.district = codeArr[2];
      // this.ruleForm.venue = area.join('/')
    },
    submit(type) {
      let self = this;
      // 姓名
      if (!this.form.clientName&&this.getFieldConfig("clientName", "formVisible") == "Y" &&this.getFieldConfig("clientName", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("clientName", "fieldAlias")}不能为空`);
        return;
      }
      // 联系方式
      if (!this.form.mobileNo&&this.getFieldConfig("mobileNo", "formVisible") == "Y" &&this.getFieldConfig("mobileNo", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("mobileNo", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择性别
      if (!this.form.sex&&this.getFieldConfig("sex", "formVisible") == "Y" &&this.getFieldConfig("sex", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("sex", "fieldAlias")}不能为空`);
        return;
      }
        // 岗位：
      if (!this.form.position&&this.getFieldConfig("position", "formVisible") == "Y" &&this.getFieldConfig("position", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("position", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择客户类型
      if (!this.terminalType&&this.getFieldConfig("terminalType", "formVisible") == "Y" &&this.getFieldConfig("terminalType", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("terminalType", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择负责客户
      if (!this.customerListName&&this.getFieldConfig("chargeCustomerList", "formVisible") == "Y" &&this.getFieldConfig("chargeCustomerList", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("chargeCustomerList", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择代理产品
      if (!this.productName&&this.getFieldConfig("agentProductList", "formVisible") == "Y" &&this.getFieldConfig("agentProductList", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("agentProductList", "fieldAlias")}不能为空`);
        return;
      }
      // 请选择业务员能力
      if (!this.form.businessAbility&&this.getFieldConfig("businessAbility", "formVisible") == "Y" &&this.getFieldConfig("businessAbility", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("businessAbility", "fieldAlias")}不能为空`);
        return;
      }
      // 业绩指标
      if (!this.form.performanceIndicator&&this.getFieldConfig("performanceIndicator", "formVisible") == "Y" &&this.getFieldConfig("performanceIndicator", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("performanceIndicator", "fieldAlias")}不能为空`);
        return;
      }
      // 擅长品类
      if (!this.form.adeptType.length&&this.getFieldConfig("adeptType", "formVisible") == "Y" &&this.getFieldConfig("adeptType", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("adeptType", "fieldAlias")}不能为空`);
        return;
      }
      // 专长领域
      if (!this.form.expertDomainList.length&&this.getFieldConfig("expertDomainList", "formVisible") == "Y" &&this.getFieldConfig("expertDomainList", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("expertDomainList", "fieldAlias")}不能为空`);
        return;
      }
      // 覆盖区域
      if (!this.cityList.length&&this.getFieldConfig("coverageAreaList", "formVisible") == "Y" &&this.getFieldConfig("coverageAreaList", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("coverageAreaList", "fieldAlias")}不能为空`);
        return;
      }
      // 建档时间
      if (!this.form.inputDate&&this.getFieldConfig("inputDate", "formVisible") == "Y" &&this.getFieldConfig("inputDate", "isRequired") == "Y") {
        this.$message.error(`${this.getFieldConfig("inputDate", "fieldAlias")}不能为空`);
        return;
      }
      
      if (!this.form.createUserTenantGuid) {
        this.$message.error('请选择指派公司')
        return
      }
      if(!this.form.createUserId){
        this.$message.error('请选择业务指派人')
        return 
      }
      if (this.$NameCheck(this,this.form.clientName,'clientName')) { // todo 姓名长度校验
        return
      }

      self.fullscreenLoading = true;
      // this.form.tenantGuid = localStorage.guid;
      let query = JSON.parse(JSON.stringify(this.form));
      if(this.terminalType == 1){
        query.chargeCustomerList = this.currentMedSelect;
      }else{
        query.chargeCustomerList = this.currentFranSelect;
      }
      //产品
      if(this.multipleSelectionGoodsList&&this.multipleSelectionGoodsList.length>0){
        query.agentProductList = this.multipleSelectionGoodsList;
      }
      //业绩指标
      if(query.performanceIndicator){
        query.performanceIndicator = Number(query.performanceIndicator)
      }
      //擅长品类
      if(query.adeptType&&query.adeptType.length>0){
        query.adeptType = query.adeptType.join('、')
      }else{
        query.adeptType = '';
      }
      //专长领域
      if(query.expertDomainList&&query.expertDomainList.length>0){
        query.expertDomainList = [{ expertCustomerType: query.expertDomainList[0], expertCustomerName: query.expertDomainList[1] }]
      }
      //覆盖区域
      if(this.cityList&&this.cityList.length>0){
        query.coverageAreaList = []
        this.cityList.forEach(i=>{
          let obj = {
            province: null,
            city: i[1],
            district: null
          }
          query.coverageAreaList.push(obj)
        })
      }
      query.accountMonth = query.accountMonth.replace('-', '')
      query.serviceTenantGuid = localStorage.guid;
      query.createUserTenantName = this.createUserTenantName;
      if (query.guid) {
        self.api.put(`/${serverConfig.msPersonnelService}/address-list/data/pc-update`, query).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功！');
            if(type == 1){
              this.form = {
                guid: '',
                tenantGuid: '',
                clientName: '',//姓名
                tenantGuid: "",
                mobileNo: "",
                sex: "",
                positionGuid:'',
                department:'',//部门
                departmentGuid:'',
                clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
                chargeCustomerList:[],//选择类型 2商业公司 1医院
                agentProductList:[],//产品
                businessAbility:[],//业务员能力
                performanceIndicator:'',//业绩指标
                adeptType:[],//擅长品类
                expertDomainList:[],//专长领域
                coverageAreaList:[],//覆盖城市
                inputDate: recentDate.getNowDay(),
                accountMonth: null,
                createUserId:'',
                createUserMobile:'',
                createUserName:'',
                createUserTenantGuid: '',
                bizState:'Y',//启用状态
              }
              this.terminalType = '';
              this.currentFranSelect = [];
              this.currentMedSelect = [];
              this.customerListName = '';
              this.joinKeyWords = '';
              this.productName = '';
              this.cityList = '';
              this.getCompany().then(()=>{
                this.getMedList(1);
                this.getFranchiseeList(1);
                this.getProduct(1)
              })
            }else{
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            }
            
          } else {
            self.$message.error(res.data.msg);
          }
        }).catch(()=>{
          self.fullscreenLoading = false;
        });
      } else {
        self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-add`, query).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('新增成功！');
            if(type == 1){
              this.form = {
                guid: '',
                tenantGuid: '',
                clientName: '',//姓名
                tenantGuid: "",
                mobileNo: "",
                sex: "",
                position: '',//岗位
                positionGuid:'',
                department:'',//部门
                departmentGuid:'',
                clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
                chargeCustomerList:[],//选择类型 2商业公司 1医院
                agentProductList:[],//产品
                businessAbility:[],//业务员能力
                performanceIndicator:'',//业绩指标
                adeptType:[],//擅长品类
                expertDomainList:[],//专长领域
                coverageAreaList:[],//覆盖城市
                inputDate: recentDate.getNowDay(),
                accountMonth: null,
                createUserId:'',
                createUserMobile:'',
                createUserName:'',
                createUserTenantGuid: '',
                bizState:'Y',//启用状态
              }
              this.terminalType = '';
              this.currentFranSelect = [];
              this.currentMedSelect = [];
              this.customerListName = '';
              this.joinKeyWords = '';
              this.productName = '';
              this.cityList = '';
              this.getCompany().then(()=>{
                this.getMedList(1);
                this.getFranchiseeList(1);
                this.getProduct(1)
              })
            }else{
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        }).catch(()=>{
          self.fullscreenLoading = false;
        });
      }
    },
    chooseProduct(){
      if(!this.form.tenantGuid){
        this.$message.error('请先选择所属企业！')
        return
      }
      if(!this.form.createUserId){
        this.$message.error('请先选择业务指派人员')
        return 
      }
      this.dialogProduct = true;
      this.getProduct(1);
    },
    //获取产品数据
    getProduct(type) {
      if(!this.form.tenantGuid){
        return
      }
      if(!this.currentStaffGuid){
        return
      }
      let self = this;
      self.loading = true;
      self.productInformationList = [];
      self.pages.tenantGuid = this.form.tenantGuid;
      self.pages.staffGuid = this.currentStaffGuid;
      if(type == 1){
        self.pages.pageIndex = 1;
      }
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.pages).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data);
          self.loading = false;
          self.productInformationList = res.data.data.records;
          self.pages.totalPage = res.data.data.totalPages;
          self.pages.totalRows = res.data.data.totalRows;
          if (self.productInformationList != null) { 
            self.productInformationList.forEach((item, index) => {
              if (self.multipleSelectionGoodsList && self.multipleSelectionGoodsList.length > 0) {
                self.multipleSelectionGoodsList.forEach((i) => {
                  if (i.productGuid == item.guid) {
                    self.$nextTick(() => {
                      self.$refs.dataTableProduct.toggleRowSelection(item, true);
                    });
                  }
                });
              }
            });
          }
          console.log(self.productInformationList);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 产品多选
    handleSelectionChange(item) {
      this.multipleSelectionGoodsList = [];
      if (item && item.length > 0) {
        item.forEach((i) => {
          let obj = {
            productName:i.goodsName,
            productGuid:i.guid
          }
          this.multipleSelectionGoodsList.push(obj);
        });
      }
    },
    submitFormProduct() {
      let nameList = [];
      if (this.multipleSelectionGoodsList && this.multipleSelectionGoodsList.length > 0) {
        this.multipleSelectionGoodsList.forEach((i,index) => {
          if(index<2){
            nameList.push(i.productName);
          }
        });
        this.productName = this.multipleSelectionGoodsList.length>2?(nameList.join('、')+'等'+this.multipleSelectionGoodsList.length+'个'):(nameList.join('、'));
      } else {
        this.$message.error('请选择产品！');
        return;
      }
      this.dialogProduct = false;
    },
    getRowKeys(row) {
      return row.guid;
    },
    //获取商业公司
    getFranchiseeList(val) {
      if(!this.form.tenantGuid){
        return
      }
      let self = this;
      if (val) {
        this.franPage = {
          pageIndex: 1,
          tenantGuid: this.form.tenantGuid,
          pageSize: 10,
          franchiseeName: this.joinKeyWords,
          totalPage: 0,
          totalRows: 0,
        }
      }
      this.franLoading = true;
      this.api.postCan(
        `/${serverConfig.msCustomerService}/franchisee/data/get`,
        this.franPage
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.franLoading = false;
          this.franchiseeList = res.data.data.records;
          this.franPage.totalPage = res.data.data.totalPages;
          this.franPage.totalRows = res.data.data.totalRows;
          if (self.franchiseeList != null) { 
            self.franchiseeList.forEach((item, index) => {
              console.log(self.currentFranSelect)
              if (self.currentFranSelect && self.currentFranSelect.length > 0) {
                self.currentFranSelect.forEach((i) => { 
                  if (i.customerGuid == item.guid) { 
                    self.$nextTick(() => {
                      self.$refs.dataTableFran.toggleRowSelection(item, true);
                    });
                  }
                });
              }
            });
          }
        } else {
          this.franLoading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    sureChoose() {
      if(!this.currentFranSelect.length && !this.currentMedSelect.length){
        this.$message.error('请选择数据');
        return 
      }
      this.customerListName = '';
      if(this.terminalType == 1){
        this.currentFranSelect = [];
        let medNameList = [];
        this.currentMedSelect.forEach((i,index)=>{
          if(index<2){
            medNameList.push(i.customerName);
          }
        })
        console.log(medNameList)
      this.customerListName =  this.currentMedSelect.length>2?(medNameList.join('、')+'等'+this.currentMedSelect.length+'个'):(medNameList.join('、'))
      }else if(this.terminalType == 2){
        this.currentMedSelect = [];
        let franNameList = [];
        this.currentFranSelect.forEach((i,index)=>{
          if(index<2){
            franNameList.push(i.customerName);
          }
        })
        this.customerListName =  this.currentFranSelect.length>2?(franNameList.join('、')+'等'+this.currentFranSelect.length+'个'):(franNameList.join('、'))
      }
      this.dialogFran = false;
      this.dialogMed = false;
    },
    cancelChoose() {
      this.dialogFran = false;
      this.dialogMed = false;
    },
    handleFranSizeChange(val) {
      this.franPage.pageIndex = val;
      this.getFranchiseeList();
    },
    handleFranCurrentChange(val) {
      this.franPage.pageIndex = val;
      this.getFranchiseeList();
    },
    getMedList(val) {
      let self = this;
      if(!this.form.tenantGuid){
        return
      }
      if (val) {
        this.medPage = {
          pageIndex: 1,
          tenantGuid: this.form.tenantGuid,
          pageSize: 10,
          approvalStates: ["Y", "U"],
          totalPage: 0,
          totalRows: 0,
          medNameKeyword: this.joinKeyWords,
        }
      }
      this.medLoading = true;
      this.api.postCan(
        `/${serverConfig.msCustomerService}/med/data/get`,
        this.medPage
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.medLoading = false;
          this.medList = res.data.data.records || [];
          this.medPage.totalPage = res.data.data.totalPages;
          this.medPage.totalRows = res.data.data.totalRows;
          console.log(self.currentMedSelect)
          if (self.medList &&self.medList.length>0) { 
            self.medList.forEach((item, index) => {
              if (self.currentMedSelect && self.currentMedSelect.length > 0) {
                self.currentMedSelect.forEach((i) => {
                  if (i.customerGuid == item.guid) {
                    self.$nextTick(() => {
                      self.$refs.dataTableMed.toggleRowSelection(item, true);
                    });
                  }
                });
              }
            });
          }
        } else {
          this.medLoading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    handleMedSizeChange(val) {
      this.medPage.pageIndex = val;
      this.getMedList();
    },
    handleMedCurrentChange(val) {
      this.medPage.pageIndex = val;
      this.getMedList();
    },
    handleSelectionChangeFran(val){
      this.currentFranSelect = []
      if(val&&val.length>0){
        val.forEach(i=>{
          let obj = {
            customerGuid:i.guid,
            customerName:i.franchiseeName,
            customerType:'2'
          }
          this.currentFranSelect.push(obj)
        })
      }
    },
    handleSelectionChangeMed(val){
      this.currentMedSelect = []
      if(val&&val.length>0){
        val.forEach(i=>{
          let obj = {
            customerGuid:i.guid,
            customerName:i.medName,
            customerType:'1'
          }
          this.currentMedSelect.push(obj)
        })
      }
    },
    handleSizeChange1(val) {
      let self = this;
      self.pages.pageSize = val;
      this.getProduct();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pages.pageIndex = val;
      this.getProduct();
    },
    /**
       * @param val 对应值
       * @param formObj 表单对象
       * @param fildeName 字段key
       */
      nameBlur(val,formObj,fildeName) {
        formObj[fildeName] = this.$NameCheckBlur(this,val,fildeName)
      }
  },
  computed: {
    createUserTenantName() {
      const tenantName = this.serviceTenants?.find(item => item.guid == this.form.createUserTenantGuid)?.tenantName;
      return tenantName;
    },
  },
};
</script> 